import React, { useState } from "react";
import classNames from "classnames";

import ArrowIcon from "@/icons/arrow-down.svg";
import { SelectInterface } from "@/components/Select/Select.interface";

import styles from "./Select.module.scss";

export const Select: React.FC<SelectInterface> = ({
  options,
  className,
  onChange,
  initialSelected,
}) => {
  const [isOpen, setMenuOpen] = useState<boolean>(false);
  const [label, setLabel] = useState<string>(initialSelected.name);

  const openMenu = () => {
    setMenuOpen(true);
  };
  const closeMenu = () => {
    setMenuOpen(false);
  };

  const changeOption = (value, name) => {
    setLabel(name);
    onChange(value);
    closeMenu();
  };

  return (
    <div>
      <div className={classNames(styles.wrapper, className)}>
        <div
          onClick={closeMenu}
          className={classNames(styles.outBoundClick, isOpen && styles.active)}
        />

        <div
          onClick={isOpen ? closeMenu : openMenu}
          className={classNames(styles.trigger, isOpen && styles.active)}
        >
          {label} <ArrowIcon />
        </div>

        <div className={classNames(styles.options, isOpen && styles.active)}>
          {options.map(({ name, value }) => (
            <p
              className={styles.option}
              key={value}
              onClick={() => changeOption(value, name)}
            >
              {name}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Select;
